/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Humidityminsetpoint2Inputs */



/**
* | output |
* | --- |
* | "Minimum humidity setpoint" |
*
* @param {Ahu_History_Key_Humidityminsetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_humidityminsetpoint2 = /** @type {((inputs?: Ahu_History_Key_Humidityminsetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Humidityminsetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Minimum humidity setpoint")
	return /** @type {LocalizedString} */ ("Consigne minimum d'hygrométrie")
});
export { ahu_history_key_humidityminsetpoint2 as "ahu_history_key_humidityMinSetpoint" }